import {LobbyImage} from '@colonist/types'
import {UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSelectionView} from './UIMMatchmakingSelectionView'
import {CA} from '../../../../../../../shared/scripts/analytics/Analytics'
import {SocketLobbySend} from '../../../../../../../shared/scripts/socket/SocketLobbySend'
import {TranslationObject} from '@colonist/i18n'
import {ClientUserState} from '../../../../../../../shared/scripts/ClientUserState'

export class UIMMatchmakingSelectionPlayVsBotsView extends UIMMatchmakingSelectionView {
    constructor(matchmakingController: UIMMatchmakingController) {
        const title: TranslationObject = {key: 'strings:homePage.matchmakingPopup.playVsBots.title'}
        const imageSrc = LobbyImage.Bot

        super(matchmakingController, title, imageSrc)
        this.renderSelectionScreen()
    }

    renderSelectionScreen() {
        this.addTitle()
        this.addImage()
        this.addGameModeButtons()
    }

    private addGameModeButtons() {
        const shouldShowBeginnerModeButton = ClientUserState.userState == undefined || ClientUserState.userState.isBeginner()
        if(shouldShowBeginnerModeButton) this.addBeginnerModeButton()

        this.addEasyModeButton()
        this.addMediumModeButton()
        this.addHardModeButton()
    }

    private addBeginnerModeButton() {
        const playBeginnerMode = this.addButton({key: 'strings:homePage.matchmakingPopup.beginnerMode.title'}, {key: 'strings:homePage.matchmakingPopup.beginnerMode.description'})

        playBeginnerMode.onclick = () => {
            void SocketLobbySend.continueCampaignMode()
        }
    }

    private addEasyModeButton() {
        const playEasyBots = this.addButton({key: 'strings:homePage.matchmakingPopup.easyMode'}, {key: 'strings:homePage.matchmakingPopup.easyBots.description'})

        playEasyBots.onclick = () => {
            CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageVSBots)
            void SocketLobbySend.clickedStartEasyBotGame()
        }
    }

    private addMediumModeButton() {
        const playMediumBots = this.addButton({key: 'strings:homePage.matchmakingPopup.mediumMode'}, {key: 'strings:homePage.matchmakingPopup.mediumBots.description'})

        playMediumBots.onclick = () => {
            CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageVSBots)
            void SocketLobbySend.clickedStartMediumBotGame()
        }
    }

    private addHardModeButton() {
        const playHardBots = this.addButton({key: 'strings:homePage.matchmakingPopup.hardMode'}, {key: 'strings:homePage.matchmakingPopup.hardBots.description'})

        playHardBots.onclick = () => {
            CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageVSBots)
            void SocketLobbySend.clickedStartHardBotGame()
        }
    }
}
